<script>
export default {
  name: "LeaderBoard",
  data() {
    // 🔴 ТАБЛИЦА ДЕРЖИТ ВЫСОТУ ДО ОТВЕТА СЕРВЕРА (жалоба оунера 2026-08-30 «интерфейс постоянно
    // прыгает»). Пустая таблица — это одна строка заголовка (~30px), а с данными она вырастает до
    // 340px: экран лобби подскакивал целиком, стоило ответу дойти. Пока ответа нет, рисуем восемь
    // строк-заглушек той же высоты. Восемь, а не «сколько будет»: числа мы заранее не знаем, а
    // фиксированный `min-height` оставил бы дыру у турнира с тремя участниками.
    return { loading: true, SKELETON_ROWS: 8 };
  },
  async mounted() {
    try {
      if (this.inSeason) {
        // в турнирном аккаунте показываем ЛОКАЛЬНУЮ таблицу турнира (только его участники), а не общий ПВП
        await this.$store.dispatch('REFRESH_SEASON_STATE', this);
      } else {
        await this.$store.dispatch('GET_USERS', this)
      }
    } finally {
      this.loading = false;
    }
    this.$nextTick(() => this.scrollToMe())
  },
  computed: {
    inSeason() { return this.$store.state.season.active; },
    // Строки таблицы: турнирные (свои участники) в сезоне, иначе общий ПВП-лидерборд.
    rows() {
      if (this.inSeason) {
        return this.$store.state.season.seasonBoard.map((r) => ({
          id: 'sn_' + r.place + '_' + r.username,
          // id суб-аккаунта участника — для глазика «посмотреть настройки фигур». В архивном турнире
          // сабы удалены, сервер отдаёт null → глазик не показываем (смотреть нечего).
          viewId: r.user_id || null,
          username: r.username,
          // сила и рейтинг приходят с сервера как в общем лидерборде; прочерк — только если их нет
          // (архивный турнир: фигуры суб-аккаунтов уже удалены, силу считать не из чего)
          power: r.power == null ? '—' : r.power,
          wins: r.wins,
          loses: r.loses,
          energy: r.energy,
          rating: r.rating == null ? '—' : r.rating,
          _me: !!r.is_me,
        }));
      }
      return this.$store.state.pvp.users;
    },
    myName() {
      return this.$store.state.auth.username;
    },
    // глазик просмотра профиля показываем, когда доступно окно «Настройки фигур» (веб-клиент).
    // В ТУРНИРЕ он тоже работает: смотрим фигуры суб-аккаунта участника (id приходит в таблице).
    packEnabled() {
      return process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true';
    }
  },
  methods: {
    // id игрока, чей профиль открывает глазик: в турнире — суб-аккаунт участника, вне турнира — сам игрок
    viewIdOf(user) {
      return this.inSeason ? user.viewId : user.id;
    },
    // провалиться в окно «Настройки фигур» выбранного игрока в режиме просмотра (read-only)
    viewProfile(user) {
      const id = this.viewIdOf(user);
      if (!id) return;
      this.$router.push({ path: '/pack', query: { view: id } });
    },
    // классы для подсветки призовых мест: 1=золото, 2=серебро, 3=бронза. Остальные — без класса.
    rankClass(index) {
      return ['lb__row--gold', 'lb__row--silver', 'lb__row--bronze'][index] || '';
    },
    // ТОП-3 показываем медалькой, остальные — номером места.
    rankLabel(index) {
      return ['🥇', '🥈', '🥉'][index] || (index + 1);
    },
    isMe(user) {
      if (this.inSeason) return !!user._me; // в турнире «я» — по флагу is_me (имена участников — родительские)
      return !!this.myName && user.username === this.myName;
    },
    // прокрутить таблицу так, чтобы своя строка была видна (по центру видимой области).
    // Скроллим ТОЛЬКО внутренний контейнер .lb (не scrollIntoView — тот дёргает всю страницу).
    scrollToMe() {
      const box = this.$el;
      const row = box && box.querySelector && box.querySelector('.lb__row--me');
      if (!box || !row) return;
      const top = row.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop;
      box.scrollTop = Math.max(0, top - box.clientHeight / 2 + row.offsetHeight / 2);
    }
  }
}

</script>

<template>
  <div class="lb">
    <table>
      <!-- 🔴 Ширины колонок заданы ЗДЕСЬ (`table-layout: fixed` их слушается): иначе семь колонок
           делили ширину поровну, и на ПК ник получал столько же места, сколько «Победы», а на
           телефоне ужимался до пяти букв. Ник берёт всё, что осталось. -->
      <colgroup>
        <col class="lb__col-rank">
        <col>
        <col class="lb__col-eye">
        <col class="lb__col-num">
        <col class="lb__col-num">
        <col class="lb__col-num">
        <col class="lb__col-num lb__col-num--wide">
        <col class="lb__col-num">
      </colgroup>
      <thead>
        <tr>
          <td style="text-align: center">
            #
          </td>
          <td>
            {{ $t('leaderboard.name') }}
          </td>
          <!-- глазик подписан и в шапке: колонка читается как «посмотреть фигуры», а не как пустая -->
          <td class="lb__eyehead" :title="$t('leaderboard.viewFigures')">👁</td>
          <td style="text-align: center">
            {{ $t('leaderboard.power') }}
          </td>
          <td style="text-align: center">
            {{ $t('leaderboard.win') }}
          </td>
          <td style="text-align: center">
            {{ $t('leaderboard.lose') }}
          </td>
          <td style="text-align: center">
            {{ $t('leaderboard.energy') }}
          </td>
          <td style="text-align: center">
            {{ $t('leaderboard.rating') }}
          </td>
        </tr>
      </thead>
      <tbody>
        <!-- Каркас: строки-заглушки той же высоты, пока список игроков в пути. Неразрывный пробел —
             пустая ячейка имеет НУЛЕВУЮ высоту, и каркас не совпал бы по пикселям. -->
        <template v-if="loading && !rows.length">
          <tr v-for="n in SKELETON_ROWS" :key="'skel' + n" class="lb__skel">
            <td>&nbsp;</td>
            <td><i class="lb__skel-bar"></i></td>
            <td>&nbsp;</td>
            <td><i class="lb__skel-bar"></i></td>
            <td><i class="lb__skel-bar"></i></td>
            <td><i class="lb__skel-bar"></i></td>
            <td><i class="lb__skel-bar"></i></td>
            <td><i class="lb__skel-bar"></i></td>
          </tr>
        </template>
        <tr
          v-for="(user, index) in rows"
          :key="user.id"
          :class="[rankClass(index), isMe(user) ? 'lb__row--me' : '']"
        >
          <td class="lb__rank" style="text-align: center">
            {{ rankLabel(index) }}
          </td>
          <td class="lb__name" :title="user.username">
            {{ user.username }}
          </td>
          <!-- 🔴 Глазик — СВОЯ колонка и виден ВСЕГДА (жалоба оунера 2026-08-19): раньше он жил внутри
               ячейки имени и всплывал только при наведении, поэтому у длинных ников его срезало
               вместе с текстом, и до чужих фигур было не добраться. -->
          <td class="lb__eyecell">
            <button
              v-if="packEnabled && !isMe(user) && viewIdOf(user)"
              class="lb__eye" type="button"
              :title="$t('leaderboard.viewFigures')"
              @click="viewProfile(user)"
            >👁</button>
          </td>
          <td style="text-align: center">
            {{ user.power }}
          </td>
          <td style="text-align: center">
            {{ user.wins }}
          </td>
          <td style="text-align: center">
            {{ user.loses }}
          </td>
          <td style="text-align: center">
            {{ user.energy }}
          </td>
          <td style="text-align: center">
            {{ user.rating }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
.lb{
  margin-top: 1em;
  // 🔴 ВЫСОТА ТАБЛИЦЫ ПОСТОЯННА (жалоба оунера 2026-08-30 «интерфейс постоянно прыгает»).
  // Карточка лобби центрируется по вертикали, поэтому изменение высоты САМОГО НИЖНЕГО блока двигает
  // ВСЁ, что выше, — заголовок, кнопки фракций, «В бой». Пока список ехал, таблица была высотой в
  // одну шапку, а с данными вырастала до потолка: экран подскакивал целиком. `min-height` = `max-height`
  // → сколько бы строк ни пришло, место под таблицу одно и то же.
  min-height: 340px;
  max-height: 340px;   // под 100 строк (карточка PvP растягивается вниз вместе с таблицей)
  overflow-y: auto;
  // прокрутка есть, но полосу прокрутки прячем (кросс-браузерно)
  scrollbar-width: none;          // Firefox
  -ms-overflow-style: none;       // IE/старый Edge
  &::-webkit-scrollbar{ display: none; }  // Chrome/Safari/новый Edge
}
table{
  width: 100% ;
  // 🔴 НА УЗКОМ ЭКРАНЕ ТАБЛИЦА НЕ ВЫЛЕЗАЕТ ЗА КРАЙ (мини-апп на Z Fold в сложенном виде, ширина
  // ~344px, баг оунера 2026-08-17): семь колонок с `text-align:center` держали свою ширину по
  // содержимому и уезжали вправо. `table-layout: fixed` заставляет их делить доступную ширину.
  table-layout: fixed;
  td{
    color: yellow;
    text-align: left;
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  thead{
    position: sticky;
    top: 0;
    background: #000;
    td{
      font-weight: 600;
      color: #fff;
      border-bottom: 2px solid yellow;
    }
  }
  tbody{
    td{
      border-bottom: 1px solid #ccc;
    }
    // колонка места — узкая, приглушённая
    .lb__rank{
      width: 2.5em;
      color: #cfcfcf;
      font-weight: 600;
    }
  }
}

// Строки-заглушки на время загрузки: та же высота, вместо чисел — приглушённые полоски.
.lb__skel-bar{
  display: block;
  height: 0.7em;
  margin: 0 auto;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.12);
}
.lb__skel td{ border-bottom: 1px solid rgba(204, 204, 204, 0.25); }

// очень узкий экран (сложенный Z Fold, мини-апп): ужимаем поля и шрифт, иначе колонки не влезают
@media (max-width: 420px) {
  table td { padding: 4px 2px; font-size: 0.82em; }
}

// ШИРИНЫ КОЛОНОК (работают вместе с `table-layout: fixed`). В ПРОЦЕНТАХ, а не в em: em не зависит от
// ширины экрана, и на узком мини-аппе сумма семи колонок не влезала — таблица уезжала за край
// карточки. Ник — колонка без ширины: забирает весь остаток (тут ~30%).
.lb__col-rank{ width: 5%; }
.lb__col-eye{ width: 5%; }
.lb__col-num{ width: 11%; }
.lb__col-num--wide{ width: 14%; }   // энергия — самое длинное число (шестизначное)

.lb__name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
// колонка глазика: без полей, чтобы кнопка встала вплотную к нику и не отъедала место у ника
.lb__eyecell{
  padding: 0 !important;
  text-align: center;
}
.lb__eyehead{ text-align: center; opacity: 0.75; }
.lb__eye{
  background: none;
  border: none;
  padding: 0 2px;
  cursor: pointer;
  font-size: 1.2em;
  line-height: 1;
  opacity: 0.75;            // 🔴 виден ВСЕГДА: раньше проявлялся только на hover и на ПК его не находили
  transition: opacity 0.12s, transform 0.12s;
  // золотое свечение + тёмная обводка: эмодзи-глазик был тёмным на тёмном фоне и почти не читался (ПК)
  filter: drop-shadow(0 0 3px rgba(255, 214, 110, 0.95)) drop-shadow(0 0 1px rgba(0, 0, 0, 0.9));
}
.lb__eye:hover{ transform: scale(1.25); opacity: 1; }
tbody tr:hover .lb__eye{ opacity: 1; }

// подсветка ТОП-3: цвет номера-медали + лёгкая заливка строки
.lb__row--gold   .lb__rank{ color: #ffd700; }
.lb__row--silver .lb__rank{ color: #d8d8d8; }
.lb__row--bronze .lb__rank{ color: #cd7f32; }
.lb__row--gold   td{ background: rgba(255, 215, 0, 0.12); }
.lb__row--silver td{ background: rgba(210, 210, 210, 0.12); }
.lb__row--bronze td{ background: rgba(205, 127, 50, 0.12); }
.lb__row--gold   .lb__name,
.lb__row--silver .lb__name,
.lb__row--bronze .lb__name{ font-weight: 600; }

// СВОЯ строка: заметная жёлтая рамка сверху/снизу + заливка + жирное имя.
// Заливка поверх призовой (если игрок в топ-3, своя подсветка главнее — background перекрывает).
.lb__row--me td{
  background: rgba(255, 220, 80, 0.28);
  border-top: 2px solid yellow;
  border-bottom: 2px solid yellow;
  font-weight: 600;
  color: #fff;
}
.lb__row--me .lb__rank{ color: yellow; }

@media (max-width: 720px) {
  // больше места под таблицу лидеров: карточка PvP растягивается вниз вместе с .lb (фон 100%×100%)
  .lb{ min-height: 42vh; max-height: 42vh; margin-top: 0.8em; }
  table{
    font-size: 0.82em;
    td{ padding: 4px 3px; }
  }
  // на телефоне цифрам нужна бОльшая доля (шрифт мельче, но числа те же), нику остаётся ~23%
  .lb__col-rank{ width: 7%; }
  .lb__col-eye{ width: 6%; }
  .lb__col-num{ width: 12%; }
  .lb__col-num--wide{ width: 15%; }
}

</style>